import { Api } from 'utils';

class PlanService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/plans',params),
		save: async (params?: any) => Api.createResponse('admin/plans/save',params),
		getModules: async (params?: any) => Api.createResponse('admin/plans/modules',params),
	}

}

export default PlanService;